<template>

  <div id="app">
    <h1 display: flex>Youtube Clone Project</h1>
    <p>유튜브 API 적용</p>
    <p> 추천검새거 : [𝙋𝙇𝘼𝙔𝙇𝙄𝙎𝙏]</p>
    <p>NO AD, 전체화면,  by hwang</p>
    <!-- 폰트  -->
    <link rel="preconnect" href="https://fonts.gstatic.com">
    <link href="https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap" rel="stylesheet">

    <!-- 자식한테 받을거 -->
    <header>
    <SearchBar
      @on-keyword-enter="onKeywordEnter"
    />
    <VideoListItemDetail
      :video="video"
    />
    </header>
    <section>
      <VideoList 
        :videoList="videoList"
        @on-select-video="onSelectVideo"
      />

    </section>
   
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar'
import VideoList from '@/components/VideoList'
import VideoListItemDetail from '@/components/VideoListItemDetail'


export default {
  name: 'App',
  components: {
    SearchBar,
    VideoList,
    VideoListItemDetail,
  },
  data() {
    return {
      videoList: [],
      video: null,
    }
  },
  methods: {
    onKeywordEnter(videoList) {
      //console.log('부모에서찍음', videoList)
      this.videoList = videoList
      console.log(videoList)
    },
    onSelectVideo(video) {
      this.video = video

    },
  },
}
</script>

<style>
*{font-family: 'Nanum Pen Script', cursive;}
h1 {text-align: center; color: rgb(0, 255, 55); font-size: 5em;}
p {text-align: center; color: rgb(0, 255, 55); font-size: 2em;}
section, header {
  width: 80%;
  margin: 0 auto;
  padding: 1rem 0;
}
section {
  display: flex;
}
body { background-color: black; }
</style>
